import React from 'react';
export function Guarantee() {
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, #FDF4E7 15%, #FDF4E7 85%, #FEFAF4 100%)'
  }} data-id="element-168">
      <div className="mx-auto max-w-3xl" data-id="element-169">

        {/* Card */}
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(200,146,42,0.28)'
      }} data-id="element-170">
          {/* Header */}
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
        }} data-id="element-171">
            <div className="text-5xl mb-3" data-id="element-172">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-173">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgba(200,146,42,0.05)'
        }} data-id="element-174">
            <p className="text-sm m-0 mb-2" style={{
            color: '#6B4C35'
          }} data-id="element-175">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás para estudiar si
              querés.
            </p>
            <p className="text-sm m-0 mb-5" style={{
            color: '#6B4C35'
          }} data-id="element-176">
              Si en 7 días no es lo que esperabas:
            </p>

            <p className="text-3xl font-black m-0 mb-3" style={{
            color: '#C8922A'
          }} data-id="element-177">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black m-0" style={{
            color: '#1E1208'
          }} data-id="element-178">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 text-center" style={{
          backgroundColor: 'rgba(255,255,255,0.92)',
          borderTop: '1px solid rgba(200,146,42,0.15)'
        }} data-id="element-179">
            <p className="text-xs m-0 leading-5" style={{
            color: '#9A7B5A'
          }} data-id="element-180">
              La confianza que tenemos en el Megapack Psicología Carrera
              Resuelta nos permite hacer esa promesa sin dudar.
              <br data-id="element-181" />
              Más de 1.800 estudiantes de todo el país ya lo saben.
              <br data-id="element-182" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </div>
      </div>

      {/* Degradé inferior → conecta con Testimonials */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-183" />
    </section>;
}